import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { toast } from "react-toastify";
import { SubmitDataTransfer } from "../../Redux/WhatsappSlice/DataTransfer";

const DataTransfer = () => {
  const dispatch = useDispatch();

  const { AllClients } = useSelector((state) => state.Client);
  const [selectedClientId, setSelectedClientId] = useState("");

  useEffect(() => {
    dispatch(fetchAllClients());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedClient = AllClients?.data?.find(
      (client) => client._id === selectedClientId
    );

    if (!selectedClient) {
      toast.error("Please select a client.");
      return;
    }

    const staticIP = selectedClient?.StaticIP;
    if (!staticIP) {
      toast.error("Selected client does not have a Static IP.");
      return;
    }

    try {
      await dispatch(SubmitDataTransfer(staticIP)).unwrap();
      toast.success("Data transfer completed successfully!");
      setSelectedClientId("");
    } catch (error) {
      toast.error("Data transfer failed.");
    }
  };

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Data Transfer
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-4"
          >
            {/* Client Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Client Name</h5>
              <select
                className="w-full  bg-[#F3F8FB] border-2 border-black rounded p-2"
                value={selectedClientId}
                onChange={(e) => setSelectedClientId(e.target.value)}
              >
                <option value="">Select Client</option>
                {[...(AllClients?.data || [])]
                  .sort((a, b) => (a.WhaClientName || "").localeCompare(b.WhaClientName || ""))
                  .map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.WhaClientName}
                    </option>
                  ))}
              </select>
            </div>
            {/* Submit Button */}
            <div className="submit_Form col-span-12 lg:col-span-4 md:col-span-6 flex md:mt-5 items-center gap-2">
              <button type="submit" className="All_button">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default DataTransfer;
